import axios from 'axios'
import { API } from '../@config/apis'
import { Login, LoginResponsive, Register } from './auth.DTO'
import store from "@/store";
import { LoginType } from '@/@share/utils/common';
import { User } from '@/@share/utils/modules';
import app from '@/main';

const TOKEN = 'accessToken'
export default class AuthSerivce {

    public login(body: Login, type: LoginType) {
        return axios.post<LoginResponsive>(API.AUTH.LOGIN, { data: body, type })
            .then(rs => {
                if (rs.data.userInfo && rs.data.userInfo.enable) {
                    this.setAuth(rs.data);
                    if (rs.data.message) {
                        app.config.globalProperties.$toast.add({ severity: 'success', summary: 'Thành công ', detail: rs.data.message, group: "tr", life: 3000 });
                    }
                }
                return rs.data;
            })
            .catch(error => {
                console.log(error);
            });
    }

    public register(body: Register) {
        return axios.post(API.AUTH.REGISTER, { data: body })
    }

    public refresh() {
        return axios.post<LoginResponsive>(API.AUTH.REFRESH, {})
            .then(rs => {
                if (rs.data.userInfo && rs.data.userInfo.enable) {
                    this.setAuth(rs.data);
                }
                return rs.data;
            })
            .catch(error => {
                console.log(error);
            });
    }

    private setAuth(data: LoginResponsive) {
        const wd: any = window;
        wd.loadRouters = true;
        localStorage.setItem(TOKEN, data.accessToken);
        store.commit('updateUserInfo', data);
    }

    private setAccount(account: User) {
    }

    public getToken() {
        const token = localStorage.getItem(TOKEN);
        if (token) {
            return token;
        }
        return false;
    }

    public removeToken() {
        return localStorage.removeItem(TOKEN);
    }

}

